import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MasterService } from 'src/app/masters/master.service';
import * as CommonConstants from '../utils/common.constants';
import { OrganismModel } from '../partners/organisms/organism.model';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MedicalFileService } from '../medical-file/medical-care-plan/medical.file.service';
import { LoaderService } from '../common/loader.service';
import { SharedService } from '../utils/shared.service';

@Component({
  selector: 'app-medical-files',
  templateUrl: './medical-files.component.html',
  styleUrls: ['./medical-files.component.scss']
})
export class MedicalFilesComponent implements OnInit {

  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  columnDefs: any[];
  medicalFileSearchForm: FormGroup;
  rowData:any=[];
  nationalityList =[];
  genderList =[];
  priv_addFile: boolean;
 
  constructor(public router: Router, private masterService: MasterService,private formBuilder: FormBuilder,
    private medicalFileService:MedicalFileService,private loaderService:LoaderService, private sharedService:SharedService) { 
    this.getFromGroup(); 
  }

  ngOnInit() {
    this.priv_addFile=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_FILE);
    this.loadMasterData();
  }

  /**
    * Declare form group
    *  
    */
    private getFromGroup() {
      this.medicalFileSearchForm = this.formBuilder.group({
        'orgsmId':  new FormControl(),
        'lastName': new FormControl(),
        'firstName' : new FormControl(),
        'reference':  new FormControl(),
        'cotryId': new FormControl(),
        'townId' : new FormControl(),
        'patientNo' : new FormControl(),
        'status' : new FormControl()
      })
    }

    onRowClicked(event: any) {
      this.sharedService.nextMedicalFiledId(event.data.medfiId);
      this.sharedService.medicalFileStatus(event.data.status);
      localStorage.setItem(CommonConstants.FILE_STATUS, event.data.status);
      this.router.navigate(['/addMedicalFiles']);
      this.router.navigate(["/addMedicalFiles"], {
        state: {
          //medfiId: event.data.medfiId,
          //patieId: event.data.patieId,
          medicalFileDtls:event.data
        }
      });
    }
    addNewMedicalFile(){
      this.router.navigate(["/addMedicalFiles"], {
        state: {
          newFile:'NEW'
        }
      });
    }

    loadMasterData() {
      this.masterService.getGenderList();
      this.masterService.genderList.subscribe(value => {
        this.genderList = value;
      });
      this.masterService.nationailityList.subscribe(value => {
        this.nationalityList = value;
      });
      this.masterService.getTown().subscribe(response => {
        if (response['code'] == 'S0000') {
          this.townList = response['result'];
        }
      });
  
      this.masterService.getCountry().subscribe(response => {
        if (response['code'] == 'S0000') {
          this.countryList = response['result'];
        }
      });
      this.masterService.getOrganisms().subscribe(response => {
        if (response && response['result']) {
          this.organisms = response['result'];
        }
      })

    }

 searchMedicalFile(){
  this.loaderService.display(true);
  this.medicalFileService.searchMedicalFiles(this.medicalFileSearchForm.value).subscribe(response => {
    this.loaderService.display(false);
    this.rowData = response['result'];
    this.rowData = this.rowData.map(item => ({
      ...item,
      genderName:item.gendeCode ? this.genderList.reduce(function(prev, curr) { return (curr.genderId === +item.gendeCode) ? curr.description : prev; }, null) : null,
      nationalityName: item.cotryIdNationality ? this.nationalityList.find(obj => obj.natioId === item.cotryIdNationality).natioDescEn : null
    }))
  }, error => {
    this.loaderService.display(false);
  })
 }
 
 reset(){
   this.medicalFileSearchForm.reset();
   this.rowData=[];
 }
}
